import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
// For development purposes - replace with your actual Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyDgwoHNaFJvC12VeRlqJzILzKUOeIR_Eic",
    authDomain: "music-lesson-notetaker.firebaseapp.com",
    projectId: "music-lesson-notetaker",
    storageBucket: "music-lesson-notetaker.firebasestorage.app",
    messagingSenderId: "838107325783",
    appId: "1:838107325783:web:b07f11dd105156eced4a12"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const realtimeDb = getDatabase(app);

export default app;
